import React from 'react';
import { Typography } from 'antd';
import cn from 'classnames';
import CardTemplate from '../../../../shared/ui/CardTemplate';
import styles from './index.module.scss';

const Card = ({ children, dark, className }) => {
  return (
    <CardTemplate className={cn(styles.root, className)} dark={dark}>
      {children}
    </CardTemplate>
  );
};

Card.Header = Header;
Card.Body = Body;
Card.Action = Action;

export default Card;

function Header({ title, action }) {
  return (
    <CardTemplate.Header
      className={styles.header}
      title={
        Boolean(title) && (
          <Typography.Text className={styles.title}>{title}</Typography.Text>
        )
      }
      action={action}
    />
  );
}

function Body({ children, className }) {
  return <div className={cn(styles.body, className)}>{children}</div>;
}

function Action({ className, children }) {
  return <div className={cn(styles.action, className)}>{children}</div>;
}
